import React, { useState, useEffect } from 'react';
import axios from 'axios';
import RepoDetails from './RepoDetails';
import {motion} from 'framer-motion';
import {fadeIn} from '../variants';
import {Helmet} from "react-helmet";

function Github() {
  const [username] = useState('devzio');
  const [repos, setRepos] = useState([]);
  const [details, setDetails] = useState({});
  const [detailsLoading, setDetailsLoading] = useState(false);

  useEffect(() => {
    axios({
      method: 'get',
      url: `https://api.github.com/users/${username}/repos`,
    })
    .then(res => {
      setRepos(res.data);
    })
    .catch(error => {
      console.error('Error fetching repositories:', error);
    });
  }, [username]); 

  function renderRepo(repo) {
    return (
      <div className="row" key={repo.id} onClick={() => getDetails(repo.name)}>
        <h2 className="repo-name">
          {repo.name}
        </h2>
      </div>
    );
  }

  function getDetails(repoName) {
    setDetailsLoading(true);
    axios({
      method: 'get',
      url: `https://api.github.com/repos/${username}/${repoName}`,
    })
      .then(res => {
        setDetailsLoading(false);
        setDetails(res.data);
        console.log(res.data);
      })
      .catch(error => {
        console.error('Error fetching repository details:', error);
        setDetailsLoading(false);
      });
  }

  return (
    <motion.div
      variants={fadeIn('up', 0.2)} 
      initial="hidden"
      whileInView={'show'} 
      viewport={{once: true, amount:0.2}} 
      className='container mx-auto min-h-screen flex flex-col my-5'>
      <Helmet>  
        <title>Jasdev's Github Repository</title>
      </Helmet>
      <div
      variants={fadeIn('up', 0.5)} 
      initial="hidden"
      whileInView={'show'} 
      viewport={{once: true, amount:0.7}} 
      className='flex justify-between items-center mb-8'>
        <img src="https://avatars.githubusercontent.com/u/13974927?v=4" alt="" className='profilePic_github'/>
        <div className='flex flex-col lg:flex-row justify-between items-center gap-x-4'>
          <h1 className='h5 lg:h2 font-semibold text-accent mb-4 lg:mb-0'>Jasdev's Github Repository</h1>
          <a href="https://github.com/Devzio?tab=repositories" target="_blank" rel="noreferrer" className='btn btn-sm flex items-center'>My Github</a>
        </div>
      </div>
      <div
      variants={fadeIn('up', 0.5)} 
      initial="hidden"
      whileInView={'show'} 
      viewport={{once: true, amount:0.7}} 
      className='landing-page-container flex lg:flex-row gap-x-12 gap-y-5 flex-col-reverse'>
        <div className="left-side">
          <div className="results-container">
            {repos.map(renderRepo)}
          </div>
        </div>
        <RepoDetails details={details} loading={detailsLoading}/>
      </div>
    </motion.div>
  );
}

export default Github;
